import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-call-to-action',
  templateUrl: './call-to-action.component.html',
  styleUrls: ['./call-to-action.component.css']
})
export class CallToActionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
